export default "__VITE_ASSET__727d883b__"